document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-product-detail]').forEach(function (root) {
    initGallery(root);
  });
});

function initGallery(root) {
  var thumbs = root.querySelectorAll('[data-thumb]');
  var mainImages = root.querySelectorAll('[data-main-image]');

  thumbs.forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      var index = thumb.getAttribute('data-index');

      thumbs.forEach(function (t) {
        t.classList.toggle('is-active', t === thumb);
      });
      mainImages.forEach(function (img) {
        img.classList.toggle('is-active', img.getAttribute('data-index') === index);
      });
    });
  });
}
